import { Alignment } from '@/components/Table/types';
import { ClassNameValue } from 'tailwind-merge';

export const alignStyles: Record<Alignment, ClassNameValue> = {
  left: 'justify-start',
  center: 'justify-center',
  right: 'justify-end',
};
